import { render, staticRenderFns } from "./jiaotong.vue?vue&type=template&id=26287e30&scoped=true&"
import script from "./jiaotong.vue?vue&type=script&lang=js&"
export * from "./jiaotong.vue?vue&type=script&lang=js&"
import style0 from "./jiaotong.vue?vue&type=style&index=0&id=26287e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26287e30",
  null
  
)

export default component.exports